module.exports = __webpack_public_path__ + "static/media/analytics.09a80ae5.png";